import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-chip-list',
  templateUrl: './chip-list.component.html',
  styleUrls: ['./chip-list.component.scss'],
  host: { '[class]': 'classes' },
})
export class ChipListComponent {
  @Input() centered = false;

  get classes(): string {
    const classList: string[] = ['chip-list'];

    if (this.centered) {
      classList.push('chip-list--centered');
    }

    return classList.join(' ');
  }
}
